import { Component, OnInit, Inject } from '@angular/core';
import { LoadAdventuresService } from '../../services/load-adventures/load-adventures.service';
import { UIRouterGlobals } from '@uirouter/core';
import { WebService } from '../../../../../app/scripts/services/webService';
import { RootScopeService } from '../../services/root-scope/root-scope.service';

@Component({
  selector: 'app-destination-categories',
  templateUrl: '/ng-app/src/app/pages/destination-categories/destination-categories.component.html',
  styleUrls: ['../../../../../ng-app/src/app/pages/destination-categories/destination-categories.component.css']
})
export class DestinationСategoriesComponent implements OnInit {

  destinationsList: any;

  constructor(
    public loadAdventures: LoadAdventuresService,
    public routerGlobals: UIRouterGlobals,
    @Inject(WebService) public webService: WebService,
    @Inject(RootScopeService) public rootScopeService: RootScopeService
  ) {
    this.getDestinationLocations(this.routerGlobals.params.destinationCategory);
  }

  ngOnInit(): void { }

  getDestinationLocations(destinationName) {
    this.webService.getDestinationLocations(destinationName).then(res=>{
      this.destinationsList = res['data'][0];
      this.loadAdventures.searchData = this.destinationsList.destination_pages.slice();
      this.updateMetaData(this.destinationsList);
    }).catch(err=>{
      this.loadAdventures.errorLoadingData();
      console.log(err);
    })
  }

  updateMetaData(destinationData) {
    this.rootScopeService.updateMetaTitle(destinationData.name);
    this.rootScopeService.updateMetaDescription(destinationData.description);
    this.rootScopeService.updateMetaImage(destinationData.image_url);
  }
}
